var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"full-screen-modal"}},[_c('div',{staticClass:"edit-header"},[_vm._t("toolbar")],2),_c('div',{staticClass:"edit-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }